import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {IGlobalSettings} from "@irb/irb-settings/irb-settings.model";

@Injectable({
    providedIn: 'root'
})
export class IrbInitialSetupService {
    httpOptions = {
        headers: new HttpHeaders({
            'Content-Type':  'application/json',
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache',
            'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
        })
    };

    constructor(private _http: HttpClient) { }

    setAdminSettings(adminSettings:IGlobalSettings): Observable<Object> {
        return this._http.post('/irebalone/home-page/set-admin-setting-details', adminSettings);
    }

    getAdminSettings(): Observable<Object> {
        return this._http.get('/irebalone/home-page/get-admin-setting-details', this.httpOptions);
    }
}